import { HTTP, SC, LIQ } from "@/axios.js";
import { EventBus } from "@/event-bus.js";
const estadoMixins = {
    data() {
        return {
            cliente1: window.sessionStorage.getItem('cliente') ? JSON.parse(window.sessionStorage.getItem('cliente')) : {},
            operador: window.sessionStorage.getItem('operador') ? window.sessionStorage.getItem('operador') : '',
            generando: false,
            entregando: false,
            entregado: false,
            disponible: false,
            fecha_comsion: '2020-12-31 23:59:59',
            modalDetalles: false,
            modalAccion: false,
            selectPedido: [],
            cargandoDetalles: false,
            obtenerInfo: false,
            infoLiquidacion: undefined,
            estados: [
                {
                    codigo: 0,
                    nombre: "Todos",
                    descrip: "Pedido pagado",
                    c1: "#CFD8DC",
                    c2: "#607D8B"
                },
                {
                    codigo: 10,
                    nombre: "En preparación",
                    descrip: "Pedido pagado",
                    c1: "#FF9800",
                    c2: "#FFC107"
                },
                {
                    codigo: 20,
                    nombre: "Despachado",
                    descrip: "Pedido despachado de Planta",
                    c1: "#3f51b5",
                    c2: "#3f51b5"
                },
                {
                    codigo: 30,
                    nombre: "Disponible",
                    descrip: "Pedido llegó a la farmacia",
                    c1: "#03A9F4",
                    c2: "#0288D1",
                    envio: 0
                },
                {
                    codigo: 31,
                    nombre: "Esperando Delivery",
                    descrip: "Pedido llegó a la farmacia",
                    c1: "#00BCD4",
                    c2: "#0288D1",
                    envio: 1
                },
                {
                    codigo: 32,
                    nombre: "Domicilio no Entregado",
                    descrip: "Pedido retorna a Farmacia",
                    c1: "#e91e63",
                    c2: "#e91e63",
                    c3: "#e91e63",

                },
                {
                    codigo: 40,
                    nombre: "Entregado",
                    descrip: "Farmacia entregó productos",
                    c1: "#4CAF50",
                    c2: "#388E3C",
                    c3: "#dcedc8"
                },
                {
                    codigo: 41,
                    nombre: "Entregado en domicilio",
                    descrip: "Repartidor entregó productos",
                    c1: "#4CAF50",
                    c2: "#388E3C",
                    c3: "#dcedc8"
                },
                {
                    codigo: 42,
                    nombre: "Entregado al repartidor",
                    descrip: "Repartidor retiró productos",
                    c1: "#4CAF50",
                    c2: "#388E3C",
                    c3: "#dcedc8"
                },

                {
                    codigo: 50,
                    nombre: "Liquidado",
                    descrip: " Farmacia liquidó el pedido",
                    c1: "#7B1FA2",
                    c2: "#9C27B0"
                },
                {
                    codigo: 60,
                    nombre: "Bloqueado",
                    descrip: "Bloqueado por auditoria",
                    c1: "#9E9E9E",
                    c2: "#616161"
                },
                {
                    codigo: 70,
                    nombre: "Envio a Domicilio",
                    descrip: "PEDIDOS PARA TREGGO",
                    c1: "#2196F3",
                    c2: "#2196F3",
                    c3: "#2196F3"
                },

                {
                    codigo: 99,
                    nombre: "Anulado",
                    descrip: "Pedido anulado",
                    c1: "#F44336",
                    c2: "#FF5252"
                }

            ]
        }
    },
    methods: {
        cambiarEstadoPedido(pedido) {

            this.selectPedido = pedido
            var estados = [30, 31, 21, 32];
            console.log('cambiarEstadoPedido', pedido.estado, estados.includes(pedido.estado));
            if (estados.includes(pedido.estado)) {
                EventBus.$emit('modalAccion', true)
            }

        },


        detallePedido(pedido) {
            this.cargandoDetalles = pedido
            HTTP.post(SC + '/detallePedido2', { pedido: pedido }, {
                headers: {
                    'Authorization': `Bearer ${window.sessionStorage.getItem('token')}`,
                }
            })
                .then(res => {
                    // console.log('detallePedido', res);
                    this.modalDetalles = true
                    this.cargandoDetalles = false
                    this.selectPedido = res.data
                })
        },
        getEstado(estado) {
            let estadoData = this.estados.filter(e => {
                return e.codigo == estado
            })[0]

            return estadoData
        },
        setEstados() {
            return this.estados
        },
        getMarket(m) {
            let market = {}
            switch (m) {
                case 1:
                    market = {
                        nombre: 'FarmaOnline',
                        img: require('@/assets/fo_logo.png'),
                        iso: require('@/assets/fo_iso.png'),
                        corto: 'FO',
                        color1: '#ff8278',
                        color2: '#111111'
                    };
                    break;
                case 5:
                    market = {
                        nombre: 'FarmaOnline',
                        img: require('@/assets/fo_logo.png'),
                        iso: require('@/assets/fo_iso.png'),
                        corto: 'FO',
                        color1: '#ff8278',
                        color2: '#111111'
                    };
                    break;
                case 2:
                    market = {
                        nombre: 'Mercado Libre',
                        img: require('@/assets/ml_logo.png'),
                        iso: require('@/assets/ml_iso.png'),
                        corto: 'MELI',
                        color1: '#FFE902',
                        color2: '#002F6D'
                    };
                    break;
                default:
                    market = {
                        nombre: 'FarmaOnline',
                        img: require('@/assets/fo_logo.png'),
                        iso: require('@/assets/fo_iso.png'),
                        corto: 'FO',
                        color1: '#ff8278',
                        color2: '#111111'
                    };
                    break;
            }

            return market
        },
        getComision(p) {
            let fecha_add = JSON.parse(window.sessionStorage.getItem('cliente')).fecha_add.date;

            let comision_info = 0
            //   comision_info.comision_porcentaje = 0
            let importe = p.importe   //guarda feo en db
            if ((p.market == 1) && (fecha_add <= this.fecha_comsion)) {
                comision_info = p.comision + 3
            } else {
                comision_info = p.comision
            }
            // console.log(comision_info);
            return ((importe * comision_info)).toFixed(2)


        },
        irComision() {
            // console.log('pedidos', this.cliente1.admin_grupo, this.cliente1.codigo);
            let ruta = (this.cliente1.admin_grupo == this.cliente1.codigo) ? 'comisionesGrupos' : 'comisiones'
            this.obtenerInfo = true

            setTimeout(() => {
                this.obtenerInfo = false
                this.$router.push(
                    {
                        name: ruta,
                        query: {
                            token: window.sessionStorage.getItem('token')
                        }
                    })
            }, 150);


        },
        generarLiquidacion(pedidos) {
            console.log('pedidos', pedidos);
            this.obtenerInfo = true
            this.generando = true;
            let isAdminGrupo = (this.cliente1.admin_grupo === this.cliente1.codigo) ? true : false

            setTimeout(() => {
                let nombre = isAdminGrupo ? 'liquidarGrupo' : 'liquidar'
                this.obtenerInfo = false
                this.$router.push(
                    {
                        name: nombre,
                        query: {
                            token: window.sessionStorage.getItem('token')
                        },
                        params:
                        {
                            pedidos: pedidos
                        }
                    })
            }, 150);


        },
        generarLiquidacionOCR(liquidacion = 0) {
            // console.log('getLiquidacionesPendientes generarLiquidacion', liquidacion);
            // this.obtenerInfo = true
            this.generando = true;
            if (liquidacion) {
                this.$router.push({
                    name: "liquidacion-detalle",
                    query: {
                        token: window.sessionStorage.getItem("token")
                    },
                    params: {
                        id_fo_liq: liquidacion,
                        liquidacion: liquidacion,
                        info: {},
                    }

                })
            }
            else {
                HTTP.post(LIQ + '/nuevaLiquidacion', { cliente: this.cliente1.codigo, operador: this.operador })
                    .then(res => {
                        this.generando = false;
                        // let isAdminGrupo = (this.cliente1.admin_grupo === this.cliente1.codigo) ? true : false
                        // console.log('nuevaLiquidacion', res.data);
                        if (res.data && res.data.facturas && res.data.liquidacion && !res.data.pendientes) {

                            this.$router.push(
                                {
                                    name: 'liquidarOCR',
                                    query: {
                                        token: window.sessionStorage.getItem('token'),
                                        id_fo_liq: res.data.liquidacion
                                    },
                                    params:
                                    {
                                        id_fo_liq: res.data.liquidacion
                                    }
                                })
                        }
                        else {
                            if (res.data.pendientes && res.data.liquidacion) {
                                this.$alert('Tiene al menos una liquidación pendiente/incompleta, finalice el proceso anterior para continuar con la nueva liquidación', 'Liquidaciones pendientes', {
                                    confirmButtonText: 'VER LIQUIDACIÓN',
                                    callback: () => {
                                        this.$router.push({
                                            name: "liquidacion-detalle",
                                            query: {
                                                token: window.sessionStorage.getItem("token")
                                            },
                                            params: {
                                                id_fo_liq: res.data.liquidacion,
                                                liquidacion: res.data.liquidacion,
                                                info: res.data.datosLiq,
                                            }

                                        })
                                    }
                                })
                            }
                            else {
                                this.$alert('No se pudo generar la Liquidacion, refresque el navegador y reintente', {
                                    type: 'error'
                                })
                            }

                        }
                    })
                    .catch(() => {
                        this.generando = false;
                        this.$alert('No se pudo generar la Liquidacion, refresque el navegador y reintente', {
                            type: 'error'
                        })
                    })
            }





        },



        getInfoLiquidacion(id_fo_liq) {
            this.obtenerInfo = true
            let cliente = JSON.parse(window.sessionStorage.getItem('cliente')).codigo;

            if (cliente != 8000) {
                HTTP.post(LIQ + '/getLiquidacionesPendientes', { cliente: cliente, id_fo_liq: id_fo_liq }, {
                    headers: {
                        'Authorization': `Bearer ${window.sessionStorage.getItem('token')}`,
                    }
                })
                    .then(res => {
                        this.infoLiquidacion = res.data
                        this.obtenerInfo = false
                        //  console.log(this.infoLiquidacion);

                    })
            } else {
                this.$alert('No tiene permisos suficientes para realizar esta operación', 'No permitido', {
                    confirmButtonText: 'ACEPTAR',
                });
            }
        },
        getInfoLiquidacionRechazada(liquidacion) {
            this.obtenerInfo = true
            let cliente = JSON.parse(window.sessionStorage.getItem('cliente')).codigo;

            if (cliente != 8000) {
                HTTP.post(SC + '/getInfoLiquidacionRechazada', { cliente: cliente, liquidacion: liquidacion }, {
                    headers: {
                        'Authorization': `Bearer ${window.sessionStorage.getItem('token')}`,
                    }
                })
                    .then(res => {
                        this.infoLiquidacion = res.data
                        this.obtenerInfo = false
                        // console.log('getInfoLiquidacionRechazada', this.infoLiquidacion);

                    })
            } else {
                this.$alert('No tiene permisos suficientes para realizar esta operación', 'No permitido', {
                    confirmButtonText: 'ACEPTAR',
                });
            }
        }
    },
}
export default estadoMixins